"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTreeModel = void 0;
const operators_1 = require("rxjs/operators");
const smart_1 = require("../../smart");
class DataTreeModel extends smart_1.CollectionModel {
    constructor(idGetter, childsGetter, loader, initialValue) {
        super(idGetter, loader, initialValue);
        this.getItemChilds = childsGetter;
    }
    traverseTreeNodes(items, callback) {
        var _a;
        let current;
        const visitors = items.slice().reverse();
        while ((current = visitors.pop())) {
            if (callback(current) === true) {
                return;
            }
            visitors.push(...((_a = this.getItemChilds(current)) !== null && _a !== void 0 ? _a : []).slice().reverse());
        }
    }
    getItemById(id) {
        let foundItem = null;
        this.traverseTreeNodes(this.getValue().items, (item) => {
            if (id === this.getItemID(item)) {
                foundItem = item;
                return true;
            }
            return;
        });
        return foundItem;
    }
    updatedItemById(id, newData) {
        this.update((values) => {
            this.traverseTreeNodes(values.items, (item) => {
                if (id === this.getItemID(item)) {
                    Object.assign(item, newData);
                    return true;
                }
                return;
            });
        });
    }
    withAdditionalValues(additionalValues) {
        var _a, _b;
        const { checked, expanded } = this.getValue();
        return super.withAdditionalValues(Object.assign(Object.assign({}, additionalValues), { checked: (_a = additionalValues.checked) !== null && _a !== void 0 ? _a : checked, expanded: (_b = additionalValues.expanded) !== null && _b !== void 0 ? _b : expanded }));
    }
    fetchNode(node) {
        return this.loader(this.getValue(), node).pipe((0, operators_1.take)(1));
    }
    actualizeSelection() {
        const { selection, checked, expanded } = this.getValue();
        if (!selection.length && !checked.length && !expanded.length) {
            return;
        }
        const prevSelection = selection.slice();
        const prevChecked = checked.slice();
        const prevExpanded = expanded.slice();
        const resultSelection = [];
        const resultChecked = [];
        const resultExpanded = [];
        this.traverseTreeNodes(this.getValue().items, (item) => {
            var _a;
            const id = this.getItemID(item);
            const findedSelectedIdx = prevSelection.findIndex((selectedId) => selectedId === id);
            if (findedSelectedIdx > -1) {
                resultSelection.push(...prevSelection.splice(findedSelectedIdx, 1));
            }
            const findedCheckedIdx = prevChecked.findIndex((checkedId) => checkedId === id);
            if (findedCheckedIdx > -1) {
                resultChecked.push(...prevChecked.splice(findedCheckedIdx, 1));
            }
            const findedExpandedIdx = prevExpanded.findIndex((expandedId) => expandedId === id);
            if (findedExpandedIdx > -1) {
                const findedExpandedId = prevExpanded.splice(findedExpandedIdx, 1);
                if ((_a = this.getItemChilds(item)) === null || _a === void 0 ? void 0 : _a.length) {
                    resultExpanded.push(...findedExpandedId);
                }
            }
            if (!prevSelection.length && !prevChecked.length && !prevExpanded.length) {
                return true;
            }
            return;
        });
        this.update((prevValue) => {
            prevValue.selection = resultSelection;
            prevValue.checked = resultChecked;
            prevValue.expanded = resultExpanded;
        });
    }
}
exports.DataTreeModel = DataTreeModel;
//# sourceMappingURL=DataTreeModel.js.map